export const DelegateFunctions = (klass, delegateName, functions) => {
  functions.forEach(funcName => {
    klass.prototype[funcName] = function (...args) {
      return this[delegateName][funcName](...args);
    };
  });
};

export const DelegateProperties = (klass, delegateName, properties) => {
  properties.forEach(prop => {
    Object.defineProperty(klass.prototype, prop, {
      get: function () {
        return this[delegateName][prop];
      },
      set: function (value) {
        this[delegateName][prop] = value;
      },
    });
  });
};
